import { useEffect } from 'react';

import Layout from "../../hocs/layout/Layout";
import NavBar from "../../components/navigation/Navbar";
import Footer from "../../components/navigation/Footer";
import PoliticaPrivacidad from "../../components/legal/PoliticaPrivacidad";

function PoliticaPrivacidadPage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Layout>
            <NavBar />
            <div>
                <PoliticaPrivacidad />
            </div>
            <Footer />
        </Layout>
    );
}

export default PoliticaPrivacidadPage;
